import React from 'react';
import { CredentialTemplateTypeTag } from 'app/views/settings/credentials/components/CredentialTemplateTypeTag';
import { Flex } from 'core/components';

const CredentialTypeOptionRenderer = ({
  label,
  value,
  selectItem,
  className,
  meta,
  selected,
  handleOptionRef,
  focused
}) => {
  const ariaProps = {};
  if (selected) {
    ariaProps['aria-selected'] = selected;
  }

  return (
    <Flex
      justifyContent="space-between"
      onClick={() => selectItem(value)}
      role="option"
      {...ariaProps}
      tabIndex={focused && handleOptionRef ? '0' : undefined}
      ref={focused && handleOptionRef}
      key={value}
      className={className}
    >
      {label}
      {meta && <CredentialTemplateTypeTag inline withIcon />}
    </Flex>
  );
};

export default CredentialTypeOptionRenderer;
